import styles from "./calculdora.module.css";

const Pantalla = ({ valor }) => {
  return <div className={styles.pantalla}>{valor}</div>;
};

export default Pantalla;
